import { Box, ContentBlock, Heading, Stack, Text } from 'braid-design-system';

import { TextLink } from 'src/components/Link/Link';
import { TRACKING_CODES } from 'src/constants';
import { links } from 'src/links';

export const PageIntro = () => (
  <Box paddingY={['xlarge', 'xlarge', 'xxlarge']} paddingX="gutter">
    <ContentBlock align="left">
      <Stack space="large">
        <Heading level="1">Connected Partners</Heading>
        <Text size="large">
          <span>
            Our Connected Partners support solutions that help you get the most
            value out of SEEK. If you wish to connect your SEEK Account to your
            Recruitment Software Provider, visit
          </span>{' '}
          <TextLink
            href={links.LINK_YOUR_SOFTWARE.path}
            tracking={links.LINK_YOUR_SOFTWARE.tracking}
          >
            Link your software
          </TextLink>
          <span>.</span>
        </Text>
        <Text size="large">
          <span>
            Need further help understanding what solutions are available, please
            reach out to your Account Manager or contact our
          </span>{' '}
          <TextLink
            href="/contactus"
            tracking={TRACKING_CODES.contact_us_link_clicked}
          >
            Customer Service Team
          </TextLink>
          <span>.</span>
        </Text>
      </Stack>
    </ContentBlock>
  </Box>
);
